<template>
     <vs-dialog prevent-close v-model="active" @close="getBorrar">
        <template #header>
          <h4 class="not-margin">
            Editar {{tipoEditor}}
          </h4>
        </template>
        <div class="con-form">
          <h6 v-if="row && row.abono"><span style="text-transform: capitalize">{{tipoEditor}}</span> actual: <strong>{{row.abono | currency}}</strong></h6>
          <form autocomplete="off">
            <label>Monto</label>
            <vs-input class="pl-0" v-model="monto" placeholder="Monto" @input="getMonto()">
              <template #message-danger v-if="montoNoConcidio">
                  El monto debe ser {{tipoEditor == 'monto' ? 'mayor' : 'menor'}} o igual al cargo {{tipoEditor == 'monto' ? row.saldo : row.abono | currency}}
              </template>
            </vs-input>
          </form>
          <form autocomplete="off">
            <label>Razón</label>
            <vs-select  placeholder="Seleccionar razón" class="aqui pt-0 pl-0" filter :key="razonId" v-model="razon" :disabled="!razones.length" @input="getMonto()">
                <template v-if="razones.length">
                    <vs-option v-for="option in razones" :key="option.id"  :label="option.text" :value="option.id">
                        {{option.text}}
                    </vs-option>
                </template>
                <template v-else>
                    <vs-option label="No hay datos" :value="0">
                      No hay datos
                    </vs-option>
                </template>
            </vs-select>
          </form>
        </div>
        <template #footer>
          <div class="footer-dialog" style="display:flex;">  
            <vs-button block danger class="color-red" @click="getBorrar">
              Cancelar
            </vs-button>
            <vs-button block success @click="postEditarMonto()" :disabled="botonHabilitado">
              Aceptar
            </vs-button>          
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import profesor from '../../../../api/requests/landing-profesor.js'

export default {
    props:[
      'value',
      'row',
      'institucion',
      'tipoEditor'
    ],
    data () {
        return {
            active: false,
            razon: '',
            razones: [],
            razonId: (new Date()).getTime(),
            monto: '',
            montoNoConcidio: false,
            botonHabilitado: true,
            institucionNivel: []
        }
    },
    methods: {
      getBorrar(){
        this.monto = ''
        this.razon = ''
        this.montoNoConcidio = false
        this.active = false
      },
      async getRazones(){
        try{
          this.razones = []
          if(this.tipoEditor == 'monto'){
            const {data: response} = await profesor.getRazones()
            this.razones = response
            this.razonId = (new Date()).getTime()
          }else if(this.tipoEditor == 'abono'){
            const {data: response} = await profesor.getRazonesAbono()
            this.razones = response
            this.razonId = (new Date()).getTime()
          }
        }catch{

        }
      },
      getMonto(){
        if(this.tipoEditor == 'monto'){
          if(this.row.categoria != 'servicio'){
            if(this.monto < this.row.saldo){
                this.montoNoConcidio = true
            }else {
                this.montoNoConcidio = false
            }
            
            if(this.razon != '' && this.monto >= this.row.saldo ){
                this.botonHabilitado = false
            }else{
                this.botonHabilitado = true
            }
          }else{
            if(this.monto < 0){
                this.montoNoConcidio = true
            }else {
                this.montoNoConcidio = false
            }
            if(this.razon != '' && this.monto > 0 ){
                this.botonHabilitado = false
            }else{
                this.botonHabilitado = true
            }
          }
        }else if(this.tipoEditor == 'abono'){
          if(this.monto > this.row.abono){
              this.montoNoConcidio = true
          }else {
              this.montoNoConcidio = false
          }
          if(this.razon != '' &&  this.monto < this.row.abono && this.monto != ''){
              this.botonHabilitado = false
          }else{
              this.botonHabilitado = true
          }
        }
      },
      async postEditarMonto(){
        const loading = this.$vs.loading()
        try{
            
            const formData = new FormData()
            formData.append('movimiento_id', this.row.movimiento_id)
            formData.append('monto', this.monto)
            formData.append('razon_cambio_id', this.razon)
            const response = await profesor.postEditarMonto(formData)
            this.$vs.notification({
                progress: 'auto',
                color: 'success',
                position: null,
                title: 'Operación éxitosa'
            })
            this.$emit('refreshTable')
            loading.close()
            this.getBorrar()
        }catch{
            this.$vs.notification({
                progress: 'auto',
                color: 'success',
                position: null,
                title: 'Hubo un error',
                text: 'Favor de contactar al administrador'
            })
            loading.close()
        }
      }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        row(){
          this.getRazones()
        }
    }
}
</script>
